import { Controller as n } from "@hotwired/stimulus";
class r extends n {
  connect() {
    this.sequence = 0;
  }
  add(t) {
    t.preventDefault();
    const e = String(this.templateTarget.innerHTML).replace(new RegExp(this.recordValue, "g"), `${Date.now()}_${++this.sequence}`);
    this.targetTarget.insertAdjacentHTML("beforebegin", e);
  }
  remove(t) {
    t.preventDefault();
    const e = t.target.closest(this.wrapperSelectorValue);
    if (e.dataset.newRecord === "true")
      e.remove();
    else {
      e.style.display = "none";
      const a = e.querySelector(":scope > input[name*='_destroy']");
      if (a)
        a.value = "1";
      else
        e.remove();
    }
  }
}
r.targets = ["target", "template"];
r.values = {
  wrapperSelector: {
    type: String,
    default: ".nested-form-wrapper"
  },
	record: {
    type: String,
    default: "NEW_RECORD_DEFAULT",
	}
};
export {
  r as default
};
